const ERROR_MESSAGES = {
  otpNotValid: 'The OTP entered is not valid. Please try again.',
  otpCodeInvalid:
    'The OTP code you entered is invalid. Please check and try again.',
  internalError:
    'Something went wrong. Please contact support at hey@zeme.io and describe your issue.',
  emailExist: 'Email already exist.',
  phoneExist: 'Phone Number already exist.',
  FILE_SIZE_EXCEED: `The following file(s) exceed the maximum size limit of #FILE_SIZE#MB: #FILE_NAMES#. Please upload files smaller than #FILE_SIZE#MB.`,
  somethingWentWrong: 'Something went wrong. Please try again later.',
  dragAndDropError:
    'Drag and drop documents between different categories is not allowed.',
  accountNotFound: 'account_not_found',
  accountAlreadyExists: 'account_already_exists',
  failedToSendOtp: 'Failed to send OTP',
  userTypeNotSelected: 'User type not selected',
  failedToSendSignupOtp: 'Failed to send signup OTP',
  failedToResendOtp: 'Failed to resend OTP',
  failedToCompleteSignup: 'Failed to complete signup. Please try again.',
  failedToCompleteAgentSignup:
    'Failed to complete agent signup. Please try again.',
  emailNotFound: 'Email not found',
  verificationCodeRequired: 'Verification code is required',
  failedToResendVerificationEmail: 'Failed to resend verification email',
  failedToUpdateEmailAndSendVerification:
    'Failed to update email and send verification',
  failedToUpdatePhoneAndSendVerification:
    'Failed to update phone and send verification',
  googleSignupFailed: 'Google signup failed. Please try again.',
  appleSignupFailed: 'Apple signup failed. Please try again.',
  phoneNumberRequiredForOAuth: 'Phone number is required for OAuth signup',
  phoneNumberNotFound:
    'Phone number not found. Please restart the registration process.',
  userDetailsNotFound:
    'User details not found. Please restart the registration process.',
  COPY_LINK_FAILED: 'Failed to copy link. Please copy manually.',
  phoneNumberAlreadyExists: 'This phone number is already registered.',
  emailAlreadyExists: 'This email is already registered.',
  noPropertyFound: 'No property found.',
};

const AUTH_MSG = {
  sessionExpired: 'Session expired',
  loginSuccess: 'You are successfully logged in.',
  logoutSuccess: 'You have been logged out successfully.',
  deleteSuccess:
    'Your account has been successfully queued for deletion. Please contact hey@zeme.io with any questions or concerns!',
  subscribeSuccess:
    'You have successfully subscribed to the plan. Thank you for choosing our service!',
  cardUpdatedSuccess:
    'Your card details have been successfully updated. Thank you for keeping your information up to date!',
  subscriptionCancelled:
    'Your subscription has been successfully cancelled. Thank you for being a part of our service.',
};

const PROPERTY_MSG = {
  closeSuccess: 'Property closed successfully',
  openSuccess: 'Property opened successfully',
  someoneNotOnZeme: 'Someone else not on the Zeme platform',
  noLongerAvailable: 'No longer available',
};

const VALIDATION_MESSAGES = {
  required: '*Required.',
  validEmail: 'Please enter a valid email address.',
  invalidDate: 'Please enter a valid date (MM/DD/YYYY).',
  selectUserType: 'Please select a user type first',
  fillAllRequiredFields: 'Please fill in all required fields',
  selectValidAddress:
    'Please select a valid address from the suggestions. You cannot enter a custom address.',
  firstNameCharacterLimit:
    'Your Legal First Name must be at least 2 characters long',
  middleNameCharacterLimit:
    'Your Legal Middle Name must be at least 1 characters long',
  lastNameCharacterLimit:
    'Your Legal Last Name must be at least 2 characters long',
  primaryAddressCharacterLimit:
    'Address Line 1 must be at least 1 characters long',
  cityCharacterLimit: 'City must be at least 2 characters long',
  stateCodeInvalid: 'Inavlid state code',
  zipCodeCharacterLimit: 'ZIP code must be exactly 5 digits',
  ssnNumberCharacterLimit: 'Social Security Number must be exactly 9 digits',
  termsRequired: 'Please accept the terms.',
  accuracyRequired: 'Please provide your confirmation.',
  password: 'Password must be at least 8 characters',
  passwordUpperChar: 'Password must contain at least one uppercase letter',
  passwordNumberChar: 'Password must contain at least one number',
  passwordSpecialChar: 'Password must contain at least one special character',
  confirmPassword: 'Confirm password must be matched with password.',
  onlyDigits: 'Phone number must only contain digits',
  validPhone: 'Phone number must be valid.',
  maxTenDigits: 'Phone number can have at most 10 digits',
  maxElevenDigits: 'Phone number can have at most 11 digits',
  timeFormat: 'Invalid time. Please enter a time between 00:00 and 12:00.',
  UtilityOne: 'At least one utility is required',
  creditMsg:
    'Ensure this value is greater than or equal to 300 or less than or equal to 850',
  onlyNumber: 'Please enter valid numbers',
  fileRequired: 'Atleast one file is required.',
  nNumberOfFilesRequired: 'Please select at least three files to proceed.',
  requiredRequestedDocuments:
    'Please provide all requested documents by agent.',
  ageValidation: 'You must be at least 18 years old.',
  otpValidation: 'Please enter a valid OTP.',
  valueRequired: 'Value is required',
  creditCheckTemplateStepRequired: `Please complete all other steps before initiating the Credit Check.`,
  templateAllOtherStepsRequired: `Please complete all other steps before initiating the Template Form.`,
  selectAtLeastOnePet: 'Please select atleast one pet.',
  coApplicantEmailAlreadyExist:
    'You have already invited this user to this application, it might take a few minutes to receive this invite.',
  appleEmailNotFound: `We weren't able to find an email associated with your account. To proceed, please use the regular registration.`,
  applePrivateEmail: `Uh-oh! It seems you're using a masked Apple email address, which isn't supported for signups. To continue, please use the regular registration.`,
  invalidCharacters:
    'This field can only contain letters, numbers, hyphens, single quotes, commas, periods, and spaces',
  firstNameMaxLength: 'Your Legal First Name cannot exceed 50 characters',
  lastNameMaxLength: 'Your Legal Last Name cannot exceed 50 characters',
  middleNameMaxLength: 'Your Legal Middle Name cannot exceed 50 characters',
  primaryAddressMaxLength: 'Address cannot exceed 50 characters',
  cityMaxLength: 'City cannot exceed 27 characters',
  tuAddressInvalidCharacters:
    "Invalid character: Only letters, numbers, spaces, and these symbols are allowed # () & , . - ' _ + ~ / * ",
  tuCityInvalidCharacters: `Invalid character: Only letters, spaces, and these symbols are allowed . ' - ,`,
  companyAddressLineTwoInvalidCharacters:
    "Invalid character. Only letters, numbers, spaces, and these symbols are allowed: #, (), &, ',', ., ', -, _, +, ~, /, *.",
  onlyCsvAndXLXS: 'Only CSV and XLSX files are allowed.',
  noHeadersFound:
    'No headers found in the uploaded file. Please check your file and try again.',
  notValidCsvAndXLXS:
    'Failed to parse file. Please upload a valid CSV or XLSX file.',
  tagName: 'Tag name cannot exceeds 25 characters',
  invalidPhone: 'Please enter valid phone number.',
  invalidEmail: 'Please enter valid email address.',
  invalidUserType: 'Make sure to select their role.',
  duplicateEmail: 'This email is already added or matches your own email.',
  emptyDescription: 'Please provide a description for your property.',
};

const SUCCESS_MESSAGES = {
  createdMessage: 'Successfully created.',
  successfulRegister:
    'Registration successful. Please verify your email before logging in.',
  registrationSuccessful: 'Registration successful!',
  updatedMessage: 'Successfully updated',
  signNotificationSent: 'Notification sent successfully to the renter.',
  applicationAccepted: 'Application accepted successfully.',
  applicationRejected: 'Application rejected successfully.',
  otpVerifiedSuccessfully: 'OTP verified successfully.',
  emailVerifiedSuccessfully: 'Email verified successfully!',
  verificationEmailResent: 'Verification email resent!',
  verificationCodeSentToNewEmail: 'Verification code sent to your new email!',
  LINK_COPIED: 'Link copied successfully',
  DOCUMENT_UNLINKED: 'Document(s) unlinked successfully',
  CREDIT_BYPASS: 'Credit bypassed successfully',
  REVERT_CREDIT_BYPASS: 'Credit bypass reverted successfully',
  NYLAS_ACCOUNT_LINKED: 'Zeme AI CRM successfully linked.',
  TAG_DELETE: 'Tag deleted successfully.',
  ACCOUNT_UPDATE: 'Account details updated successfully.',
  emailVerificationSent: 'Verification email sent. Please check your inbox.',
  emailUpdated: 'Your email has been updated successfully.',
  phoneVerificationSent: 'Verification code sent. Please check your phone.',
  phoneUpdated: 'Your phone number has been updated successfully.',
  applicationWithdrawn: 'Application withdrawn successfully.',
  applicationRequestApproved: 'Application request approved successfully.',
};

const PRICING_MSG = {
  NO_PAYMENT_METHOD_FOUND: `Please provide a payment method to upload the property.`,
  UPDATE_PAYMENT_METHOD_MSG: `Your previous payment method failed. Please update your payment details.`,
  ADD_PAYMENT_METHOD: 'Add Payment Method',
  UPDATE_PAYMENT_METHOD: 'Update Payment Method',
  REOPEN_PROPERTY_WITH_PRICING: `30 days have passed since last payment for this property. Re-opening this property will result in a #PRICE# charge.`,
  REOPEN_PROPERTY_WITH_PRICING_WITH_FREE_PROPERTY: `Re-opening this property will result in a #PRICE# charge.`,
  REOPEN_APPLICATION_AND_PROPERTY:
    'To reopen this application you must reopen this property.',
  REOPEN_APPLICATION: 'Do you want to reopen this application?',
  REOPEN_APPLICATION_WITH_PRICING:
    'To reopen this application you must reopen this property. Reopening this property will result in a #PRICE# charge.',
  REOPEN_APPLICATION_SUCCESS: 'Application reopened successfully',
};

export {
  VALIDATION_MESSAGES,
  AUTH_MSG,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  PROPERTY_MSG,
  PRICING_MSG,
};
